(function () {
  function init(slider) {
    if (slider.hasAttribute('data-et-ba-init')) return;
    slider.setAttribute('data-et-ba-init', '');

    var frame = slider.querySelector('.et-ba__frame');
    var range = slider.querySelector('[data-et-ba-range]');
    if (!frame || !range) return;

    function apply() {
      frame.style.setProperty('--et-ba-pos', range.value + '%');
    }

    range.addEventListener('input', apply);
    apply();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-et-ba]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-et-ba]')) {
      initAll(event.target);
    }
  });
})();
